import React from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import { CreateProvider } from './contexts/CreateContext';
import AuthInitializer from './components/auth/AuthInitializer';
import AppRouter from './components/common/AppRouter';
import './assets/styles/global.css';

function App() {
  return (
    <ThemeProvider>
      <CreateProvider>
          <AuthInitializer>
            <AppRouter />
          </AuthInitializer>
      </CreateProvider>
    </ThemeProvider>
  );
}

export default App;
